// extracted by mini-css-extract-plugin
export default {"actionsView":"styles_actionsView__dtsZG","singleAction":"styles_singleAction__AWvS2","ui-spin":"styles_ui-spin__Cepcg"};